import {createSlice} from "@reduxjs/toolkit";

const modalsSlice = createSlice({
	name: 'modals',
	initialState: {
		addingAlert: null, // holds an alert
		editingAlert: null, // holds a zone
		linkingDiscord: null, // holds a URL to auth Discord
		showingOverQuota: false,
		showingHelp: false,
		error: null
	},
	reducers: {
		showAddingAlert: (state, action) => {
			return {...state, editingAlert: null, addingAlert: action.payload};
		},
		showEditingAlert: (state, action) => {
			return {...state, addingAlert: null, editingAlert: action.payload};
		},
		showLinkingDiscord: (state, action) => {
			return {...state, linkingDiscord: action.payload};
		},
		showOverQuota: (state, action) => {
			return {...state, showingOverQuota: !!action.payload};
		},
		showHelp: (state, action) => {
			return {...state, showingHelp: !!action.payload};
		},
		showError: (state, action) => {
			return {...state, error: action.payload };
		}
	}
});

export const {showAddingAlert, showEditingAlert, showError, showLinkingDiscord, showOverQuota, showHelp} = modalsSlice.actions;
export default modalsSlice.reducer;